import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

interface AuthGuardProps {
  children: ReactNode;
}
// This component checks if the user is authenticated before rendering its children.
export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
}